import { RepositoryFactory } from 'shared/repositories/RepositoryFactory'

const AlbumRepository = RepositoryFactory.get('album');

const state = {
  likesTotal: 0,
  liked: false,
  item: {},
  userItems: [],
  storyItems: [],
  storyIndex: 0,
  comments: [],
  loading: false,
  loadingComments: false,
  savingComment: false
}

const actions = {
  getItem ({ commit }, params) {
    commit('SET_LOADING', true);
    return new Promise((resolve, reject) => {
      return AlbumRepository.getItem(params.item, params.filter).then(response => {
        const data = response.data;
        commit('SET_LIKES_TOTAL', data.cnt_likes);
        commit('SET_LIKED', data.liked_by_client);
        commit('SET_ITEM', data);

        if (data.story_pois.length) {
          commit('SET_STORY_ITEMS', data.story_pois);
        } else if (data.related_story_pois.length) {
          commit('SET_STORY_ITEMS', data.related_story_pois);
        } else {
          commit('SET_STORY_ITEMS', []);
        }

        commit('SET_LOADING', false);
        resolve(data);
      }).catch((error) => {
        commit('SET_ITEM', null);
        commit('SET_STORY_ITEMS', []);
        commit('SET_LOADING', false);
        reject(error);
      });
    })
  },

  deleteItem ({ commit }, itemId) {
    commit('SET_LOADING', true);
    return new Promise((resolve, reject) => {
      return AlbumRepository.deleteItem(itemId).then(response => {
        const data = response.data;
        commit('SET_LOADING', false);
        resolve(data);
      }).catch((error) => {
        commit('SET_LOADING', false);
        reject(error);
      });
    })
  },

  getUserItems ({ commit }, params) {
    return new Promise((resolve, reject) => {
      return AlbumRepository.getItems(params).then(response => {
        const data = response.data;
        commit('SET_USER_ITEMS', data);
        resolve(data);
      }).catch((error) => {
        commit('SET_USER_ITEMS', null);
        reject(error);
      });
    })
  },

  getComments ({ commit }, itemId) {
    commit('SET_LOADING_COMMENTS', true);
    commit('SET_COMMENTS', {});
    return new Promise((resolve, reject) => {
      return AlbumRepository.getComments(itemId).then(response => {
        const data = response.data;
        commit('SET_COMMENTS', data);
        commit('SET_LOADING_COMMENTS', false);
        resolve(data);
      }).catch((error) => {
        commit('SET_LOADING_COMMENTS', false);
        reject(error);
      });
    })
  },
  postComment ({ commit }, params) {
    commit('SET_SAVING_COMMENT', true);
    return new Promise((resolve, reject) => {
      return AlbumRepository.postComments(params.item, params.comment).then(response => {
        const data = response.data;
        commit('SET_SAVING_COMMENT', false);
        resolve(data);
      }).catch((error) => {
        commit('SET_SAVING_COMMENT', false);
        reject(error);
      });
    })
  },
  likeItem ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      return AlbumRepository.likeItem(itemId).then(response => {
        const data = response.data;
        commit('SET_LIKES_TOTAL', data.cnt_likes);
        commit('SET_LIKED', data.liked);
        resolve(data);
      }).catch((error) => {
        reject(error);
      });
    })
  }
}

const mutations = {
  SET_THEMES (state, themes) {
    state.themes = themes;
  },
  SET_SERIES (state, series) {
    state.series = series;
  },
  SET_ITEM (state, item) {
    state.item = item;
  },
  SET_PAGINATION (state, pagination) {
    state.pagination = pagination;
  },
  SET_LOADING (state, loading) {
    state.loading = loading;
  },
  SET_LOADING_COMMENTS (state, loading) {
    state.loadingComments = loading;
  },
  SET_SAVING_COMMENT (state, savingComment) {
    state.savingComment = savingComment;
  },
  SET_LIKED (state, liked) {
    state.liked = liked;
  },
  SET_LIKES_TOTAL (state, likes) {
    state.likesTotal = likes;
  },
  SET_COMMENTS (state, comments) {
    state.comments = comments;
  },
  SET_USER_ITEMS (state, userItems) {
    state.userItems = userItems;
  },
  SET_STORY_ITEMS (state, storyItems) {
    state.storyItems = storyItems;
  },
  SET_STORY_INDEX (state, storyIndex) {
    state.storyIndex = storyIndex;
  }
}

const getters = {
  getItem: state => state.item,
  getLoading: state => state.loading,
  getLiked: state => state.liked,
  getLikesTotal: state => state.likesTotal,
  getComments: state => state.comments,
  getLoadingComments: state => state.loadingComments,
  getSavingComment: state => state.savingComment,
  getUserItems: state => state.userItems,
  getStoryItems: state => state.storyItems
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
